const STORAGE_PREFIX = '_yn_pref_';

const normalizeEmail = (email) => email.trim().toLowerCase();

/** Kurzer Hash – nur für unauffällige Keys, kein Schutz gegen XSS. */
const hashKey = (email, scope = '') => {
	const input = `${scope}:${normalizeEmail(email)}`;
	let hash = 5381;

	for (let i = 0; i < input.length; i += 1) {
		hash = ((hash << 5) + hash) ^ input.charCodeAt(i);
	}

	return (hash >>> 0).toString(36);
};

const storageKey = (email, scope) => `${STORAGE_PREFIX}${hashKey(email, scope)}`;

export const readStoredCredential = (email, scope = '') => {
	try {
		const raw = localStorage.getItem(storageKey(email, scope));
		if (!raw) return null;

		const data = JSON.parse(raw);
		if (data?.v !== 1 || typeof data.p !== 'string' || !data.p) {
			return null;
		}

		const normalized = normalizeEmail(email);

		return {
			email: normalized,
			username: normalized,
			password: data.p,
		};
	} catch {
		return null;
	}
};

export const writeStoredCredential = (email, password, scope = '') => {
	if (!email || !password) return;

	try {
		localStorage.setItem(
			storageKey(email, scope),
			JSON.stringify({ v: 1, p: password }),
		);
	} catch {
		// Private mode / Quota
	}
};

export const clearStoredCredential = (email, scope = '') => {
	try {
		localStorage.removeItem(storageKey(email, scope));
	} catch {
		// ignore
	}
};
